// ----------------------------------
// App main module (entry point):
// the app will be bootstrapped here
// ----------------------------------

// vendor dependencies
import angular from 'angular';

import angularCharts from 'angular-chart.js';

import router from 'angular-ui-router';
import moment from 'moment';
import ngCookies from 'angular-cookies';
import ngFileSaver from 'angular-file-saver';
import ngFileUpload from 'ng-file-upload';
import ngMarked from 'angular-marked';
import ngMaterial from 'angular-material';
import ngMessages from 'angular-messages';
import ngResource from 'angular-resource';

// import ngStorage from 'ng-storage';

import 'angular-base64';
import 'angular-tek-progress-bar';
import 'angular-translate';
import 'angular-ui-grid';
import 'angular-ui-grid/ui-grid.css';
import 'angulartics';
import 'angulartics-google-analytics';
import 'ng-storage';
import 'jquery';

// app components/directives
import app from './containers/app/app';
import header from './containers/header/header';
import footer from './containers/footer/footer';
import components from './components/components.module';
import filters from './filters/filters.module';
import models from './models/models.module';
import services from './services/services.module';
import translations from './translations/es-ES/translations';

// app styles
import './styles/src/main.styl';

// register app component and models
import landing from './modules/landing/landing.module';
import home from './modules/home/home.module';
import adminHome from './modules/admin-home/home.module';
import adminCompany from './modules/admin-company-detail/module';
import plans from './modules/plans/plans.module';
import settings from './modules/settings/settings.module';
import reportEdit from './modules/report-edit/report-edit.module';
import login from './modules/login/login.module';
import signup from './modules/signup/signup.module';
import subscriptions from './modules/subscriptions/subscriptions.module';
import forgotPassword from './modules/forgot-password/forgot-password.module';
import passwordRecovery from './modules/password-recovery/password-recovery.module';
import verifyAccount from './modules/verify-account/verify-account.module';
import auth from './modules/auth/auth.module';
import chromeAutofillFix from './modules/fixes/chrome-autofill-fix/chrome-autofill-fix.module';

// app main module definition
const meredicte = angular.module('meredicte', [
  'angulartics',
  'angulartics.google.analytics',
  angularCharts,
  router,
  ngCookies,
  ngFileSaver,
  ngFileUpload,
  ngMarked,
  ngMaterial,
  ngMessages,
  ngResource,
  'ngStorage',
  'pascalprecht.translate',
  'base64',
  'Tek.progressBar',
  'ui.grid',
  'ui.grid.pagination',
  components.name,
  filters.name,
  models.name,
  services.name,
  auth.name,
  landing.name,
  home.name,
  adminHome.name,
  adminCompany.name,
  plans.name,
  settings.name,
  reportEdit.name,
  login.name,
  signup.name,
  subscriptions.name,
  forgotPassword.name,
  passwordRecovery.name,
  verifyAccount.name,
  chromeAutofillFix.name,
]);

meredicte
  .component('angularApp', app)
  .component('appHeader', header)
  .component('appFooter', footer)
  .config(($logProvider, $compileProvider, $urlRouterProvider, $analyticsProvider,
    $locationProvider, $translateProvider, $httpProvider, $mdThemingProvider,
    $mdDateLocaleProvider, ChartJsProvider) => {

    'ngInject';

    // ui-router config
    $urlRouterProvider.otherwise('/404');
    $locationProvider.html5Mode(true);

    $httpProvider.defaults.withCredentials = true;

    // __DEV__ is a "magic" environment var, see webpack/config.js
    /* eslint-disable no-undef */
    $compileProvider.debugInfoEnabled(__DEV__);
    $logProvider.debugEnabled(__DEV__);
    /* eslint-enable no-undef */

    // turn on/off automatic tracking
    $analyticsProvider.settings.optOut = true;

    $translateProvider
      .translations('es', translations)
      .preferredLanguage('es')
      .useSanitizeValueStrategy('escape');

    $mdThemingProvider.theme('docs-dark');

    ChartJsProvider.setOptions({ responsive: true });

    moment.locale('es-ES');

    $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
    $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];

    // Can change week display to start on Monday.
    $mdDateLocaleProvider.firstDayOfWeek = 1;

    $mdDateLocaleProvider.parseDate = (dateString) => {
      const m = moment(dateString, 'DD/MM/YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };

    $mdDateLocaleProvider.formatDate = (date) => {
      const m = moment(date);
      return m.isValid() ? m.format('DD/MM/YYYY') : '';
    };

  })
  .run((i18nService) => {
    i18nService.setCurrentLang('es');
  });

meredicte.directive('tszFileUpload', ($parse) => {

  function link(scope, element, attrs) {
    const fn = $parse(attrs.tszFileUpload);

    element.on('change', (onChangeEvent) => {
      const reader = new FileReader();

      reader.onload = (onLoadEvent) => {
        scope.$apply(() => {
          fn(scope, { $fileContent:onLoadEvent.target.result });
        });
      };
      reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0]);
    });
  }

  return {
    restrict: 'A',
    scope: false,
    link,
  };
});

meredicte.directive('bgScroll', () => {

  function link(scope) {
    angular.element(window).bind('scroll', () => {
      scope.scroll = window.pageYOffset;
      console.log(`scroll: ${scope.scroll}`);
    });
    scope.$on('$destroy', () => {
      angular.element(window).unbind('scroll');
    });
  }

  return {
    restrict: 'A',
    link,
  };
});

export default meredicte;



// WEBPACK FOOTER //
// ./src/index.js